module.exports = __webpack_public_path__ + "img/panel_pv_power_off.a44e2525.png";